import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { _side_nav } from "Benchmarking/Routes/navbarContent";
import "Benchmarking/Scss/Sidebar.scss";

const SideBar = ({ entity }) => {
  const [clickedNav, setClickedNav] = useState();
  const navigate = useNavigate();
  const handleClickFaculty = (item) => {
    setClickedNav(item.key);
    navigate(`/benchmarking/${entity}/${item.key}`);
  };
  useEffect(() => {
    const path = window.location.pathname.split("/")[3];
    const index_nav = _side_nav.findIndex((item) => item.key == path);
    setClickedNav(index_nav !== -1 ? _side_nav[index_nav].key : "");
  }, [window.location.pathname]);

  return (
    <div className="sidebar">
      <div className="menu">
        {_side_nav.slice(0, 3).map((item, index) => {
          return (
            <div
              className={`${
                clickedNav == item.key
                  ? "sidebar-item-selected"
                  : "sidebar-item"
              }`}
              key={index}
              onClick={() => handleClickFaculty(item)}
            >
              {item.svg} <p>{item.label}</p>
            </div>
          );
        })}
      </div>
      <div className="menu">
        <p className="sidebar-title">Your list</p>
        {_side_nav.slice(3, 6).map((item, index) => {
          return (
            <div
              className={`${
                clickedNav == item.key && entity == "institution"
                  ? "sidebar-item-selected"
                  : "sidebar-item"
              }`}
              key={index}
            >
              {item.svg} <p>{item.label}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SideBar;
